import { AuthEffects } from './auth.effects';
import { LayoutEffects } from './layout.effects';
import { RouterEffects } from './router.effects';
import { TabMenuEffects } from './tab-menu.effects';
import { TempStoreEffects } from './temp-store.effects';

const Effects = [AuthEffects, RouterEffects, LayoutEffects, TabMenuEffects, TempStoreEffects];

export default Effects;
